export default {
  app: {
    title: "Test 123",
  },
  refresh: {
    title: "Are you active?",
    cta: "You were registered as not active, please confirm that you are active in the next minute, if you don't you will be logged out.",
  },
  common: {
    language: "Language",
    english: "English",
    serbian: "Serbian",
    close: "Close",
    dataGridExample: "Data Grid Example",
    trademark: "TM",
    search: "Search",
    error: "Error",
    continue: "Continue",
    labelUsername: "Username",
    labelEmail: "Email",
    labelPassword: "Password",
    next: "Next",
    nextPage: "Next page",
    previousPage: "Previous page",
    back: "Back",
    goBack: "Go Back",
    ok: "Ok",
    done: "Done",
    confirm: "Confirm",
    printDownload: "Print/Download",
    cancel: "Cancel",
    remove: "Remove",
    invite: "Invite",
    save: "Save",
    complete: "Complete",
    download: "Download",
    yes: "Yes",
    no: "No",
    to: "to",
    select: "Select...",
    none: "None",
    date: {
      range: "{{start}} to {{end}}",
    },
    apply: "Apply",
    contactUs: "Contact Us",
    tryForFree: "Try for free",
    supportLink: "im.support@tremium.net",
    phoneNumber: "060/366-02-71",
  },
  pages: {
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot password",
    error: "Error",
    notFound: "Not Found",
    profile: "Profile",
    settings: "Settings",
    dashboard: "Dashboard",
    careers: "Careers",
    contact: "Contact",

    license: "License",
    privacy: "Privacy",
    terms: "Terms",
    service: "Services",
    about: {
      title: "About Us",
      text: `<p>BP consulting project d.o.o. je licencirana firma za pružanje usluga iz oblasti bezbednosti i zdravlja na radu, zaštite od požara, zaštite životne sredine, pregleda i ispitivanja, merenja, energetske efikasnosti, projektovanja, medicine rada i standaradizacije. Pod krovom firme okupili smo licencirane stručnjake sa dugogodišnjim iskustvom u struci, diplomirane inženjere i visoko obrazovane strucnjake iz drugih oblasti u cilju pružanja kvalitetnih usluga, uz nastojanje da se usavršavanjem i ulaganjem postigne konstantno povećanje istih.</p>
              <p>BP consulting project d.o.o. prerasta u privredno drustvo iz Centra za preventivni inženjering, projektovanje, edukaciju i savetovanje BP consulting, Saša Milosavljević PR osnovane 2013. godine u Kruševcu.</p>
              <p>Od samog početak BP consulting ima tesnu saradnju na svim poljima sa VIP centrom d.o.o. iz Leskovca na svim poljima rada.</p>
              <p>Po nasoj evidenciju imamo bazu podataka od više stotina pravnih lica i preduzetnika kojima smo izvrsili procenu rizika radnih mesta, a sa najozbiljnijim firmama smo nastavili dalju saradnju na planu vodenja referata iz oblasti bezbednosti i zdravlja na radu i zaštite od požara. Trenutno imamo veliki broj stalnih klijenata, dok sa nekima saradujemo duži niz godina.</p>
              <p>Nas cilj je podizanje nivoa usluga u ovoj oblasti u Republici Srbiji i njeno priblizavanje standardima EU, uz prakticnu primenu pozitivnih iskustava drugih država iz regiona i sveta.</p>
              <p>Bezbednost radnika je posao kome se ne moze pristupiti neodgovorno. Kvalitet usluga kao i preporuka mnogih uspesnih privrednika, kljuc su naseg uspeha i postojanja.</p>`,
    },
    home: {
      title: "Početna",
      hero: {
        year: "Sa vama od 2015.",
        yearSm: "Od 2015.",
        slides: {
          slide1: {
            title: "Your reliable partner for safe and responsible business",
            description:
              "Pružamo licencirane i stručne usluge iz oblasti bezbednosti i zdravlja na radu, zaštite od požara, zaštite životne sredine i još mnogo toga.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide2: {
            title: "Geotechnical and infrastructure monitoring",
            description:
              "Pratimo promene u terenu i konstrukcijama kroz napredne metode geotehničkog i infrastrukturnog monitoringa - za sigurnost i dugotrajnost svakog projekta.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide3: {
            title: "Supervision",
            description:
              "Stručni tim vrši redovan nadzor svih aktivnosti, u skladu sa važećim propisima i tehničkim normama. Fokusirani smo na pravovremeno prepoznavanje odstupanja i obezbeđivanje kvalitetne i sigurne realizacije projekta.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide4: {
            title: "Predictive maintenance of facilities",
            description:
              "Na osnovu prikupljenih podataka i praćenja stanja objekta, predlažemo optimalne trenutke za intervenciju. Na taj način se izbegavaju skupi zastoji, produžava vek trajanja objekta i održava visoka pouzdanost u radu.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide5: {
            title: "Occupational safety and health",
            description:
              "Tu smo da vam pomognemo da obezbedite potpunu usklađenost sa propisima i doprinosimo stvaranju sigurnog i produktivnog radnog okruženja. Od procene rizika do obuka i podrške tokom inspekcija - brinemo o svemu.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide6: {
            title: "Safety and health coordinator on construction sites",
            description:
              "Sprovodimo sve neophodne mere radi očuvanja zdravlja i bezbednosti zaposlenih u radnom okruženju. Naš cilj je da obezbedimo ispunjavanje zakonskih propisa i minimiziramo rizike kroz stalni nadzor i edukaciju.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide7: {
            title: "Energy efficiency",
            description:
              "Pružamo rešenja i praćenje koja smanjuju potrošnju energije i štite životnu sredinu. Naš pristup kombinuje analizu podataka i savremene tehnologije kako bismo obezbedili maksimalnu efikasnost u svim fazama rada objekta.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide8: {
            title: "Design",
            description:
              "Koordiniramo sve bezbednosne aktivnosti i osiguravamo da svi učesnici poštuju zakonske norme i procedure. Naša misija je da minimalizujemo rizike, sprečimo nezgode i obezbedimo sigurno radno okruženje tokom celokupnog procesa gradnje.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide9: {
            title: "Fire protection",
            description:
              "Implementiramo moderne sisteme i mere zaštite od požara koji zadovoljavaju sve važeće propise. Naš cilj je da smanjimo rizik od požara, obezbedimo pravovremenu reakciju i zaštitimo imovinu i živote.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide10: {
            title: "Environmental protection",
            description:
              "Sprovodimo mere i strategije koje minimizuju negativan uticaj na okolinu tokom svih faza projekta. Naš cilj je da podržimo ekološki prihvatljive prakse i doprinesemo očuvanju prirodnih resursa za buduće generacije.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide11: {
            title: "Standardizacija (HACCP, ISO)",
            description:
              "Pomažemo kompanijama da uspostave i održe sisteme u skladu sa HACCP i ISO normama, osiguravajući efikasnost procesa, usklađenost sa zakonskim zahtevima i povećanje poverenja klijenata.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide12: {
            title: "First aid",
            description:
              "Obučavamo zaposlene za pravilno pružanje prve pomoći kako bismo osigurali sigurnost i smanjili posledice nezgoda na radnom mestu. Pripremljenost i pravovremena reakcija ključni su za očuvanje zdravlja i života.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide13: {
            title: "Professional training and education",
            description:
              "Organizujemo ciljane edukacije i treninge prilagođene potrebama zaposlenih, sa fokusom na bezbednost, usklađenost i unapređenje profesionalnih kompetencija.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
          slide14: {
            title: "Inspections and testing",
            description:
              "Sprovodimo stručno izvođenje pregleda i ispitivanja u skladu sa važećim standardima i propisima. Naš cilj je pravovremeno otkrivanje potencijalnih problema i obezbeđivanje dugotrajnosti i pouzdanosti objekata i sistema.",
            ctaText: "KONTAKTIRAJTE NAS",
          },
        },
      },
      tenYearsSection: {
        header: "10 GODINA SA VAMA",
        text: "Deceniju gradimo poverenje kroz kvalitet, stručnost i posvećenost bezbednijem i efikasnijem poslovanju.",
      },
      whyChooseUs: {
        title: "WHY CHOOSE US?",
        benefits: {
          benefit1: {
            title: "Licensed team with experience",
            desc: "Više od 10 godina u praksi sa stručnjacima iz raznih oblasti.",
          },
          benefit2: {
            title: "All services in one place",
            desc: "Od bezbednosti i zdravlja na radu do energetske efikasnosti i standardizacije.",
          },
          benefit3: {
            title: "Solutions tailored to you",
            desc: "Pristup svakom klijentu je individualan, uz poštovanje važećih propisa.",
          },
          benefit4: {
            title: "Long-term client trust",
            desc: "Veliki broj klijenata sa kojima imamo višegodišnje poverenje i kontinuitet.",
          },
        },
      },
    },
    workSafetyHealth: {
      title: "Bezbednost i zdravlje na radu",
      text: `<4>Akt o proceni rizika</4>
            <p>Na većinu povreda na radu, profesionalnih bolesti i bolesti vezane za rad može se preventivno delovati, a prvi stepen preventivnih mera jeste procena rizika.</p>
            <p>Međutim pored prevencije, Akt o proceni rizika je sistemski najbitniji dokument jedne firme u oblasti bezbednosti i zdravlja na radu, kako bi se celokupni proces postavio na bezbedne i zdrave noge.</p>
            <p>U skladu sa članom 13. Zakona o bezbednosti i zdravlju na radu poslodavac je dužan da donese Akt o proceni rizika u pismenoj formi za sva radna mesta u radnoj okolini i da utvrdi način i mere za njihovo otklanjanje.</p>
            <p>Procena rizika je u suštini preispitivanje svih aspekata rada, a sprovodi se kako bi se ustanovili elementi koji mogu prouzrokavati povredu ili štetu, kako bi se opasnosti uklonile i kako bi se uvele preventivne ili zaštitne mere koje će kontrolisati rizik i stvoriti uslove da se rizikom upravlja.</p>
            <p>U saradnji sa nama lako ćete rešiti sve ove zakonske probleme, kako u najmanju ruku ne biste imali probleme sa inspekcijom rada i suočili se sa velikim novčanim kaznama, već da u potpunosti, stručno i profesionalno zaokružite jedan od bitnijih procesa u Vašoj firmi.</p>
            <p>Izrada Akta o proceni rizika je sistemski i najbitniji dokument iz oblasti bezbednosti i zdravja na radu jedne firme. Ovaj dokument čini prvi od četiri stubova uređenja ove oblasti.</p>
            <p>Drugi stub celokupnog sistema BZR čine opšti dokumenti jedne firme i to:</p>
            <3>
              <2>Pravilnik o bezbednosti i zdravlju na radu je opšti akt jedne firme kojim se definišu prava, obaveze i odgovornosti iz oblasti bezbednosti i zdravlja na radu. Treba napomenuti da ukoliko poslodavac ima manje od 10 zaposlenih ova prava, obaveze i odgovornosti sa zaposlenima mogu se regulisati odgovarajućim Aneksom Ugovora o radu ili direktno sve tačke ovog Aneksa implementirati u buduće Ugovore o radu.</2>
              <2>Pravilnik o evidencijama u oblasti bezbednosti i zdravlja na radu, kojim se propisuje način vođenja evidencije u oblasti BZR koje je dužan da vodi i čuva poslodavac. Pravilnik o evidencijama definisao je i objasnio način popunjavanja 14 obrazaca iz ove oblasti i na taj način vođenjem ove evidencije poslodavac ostavlja pisani trag u sprovođenju odgovarajućih mera, a koje su u skladu sa Zakonom i dr. podzakonskim aktima (pravilnicima, uredbama i dr.).</2>
              <2>Pravilnik o preventivnim merama za bezbedan i zdrav rad pri korišćenju sredstava i opreme za ličnu zaštitu na radu, kojim se propisuju minimalni zahtevi koje je poslodavac dužan da ispuni u obezbeđivanju primene preventivnih mera pri korišćenju sredstava i opreme za ličnu zaštitu na radu. U skladu sa pravilnikom poslodavac je u obavezi sa izradi Prilog 1, koji predstavlja Pregled opasnosti i štetnosti koje zahtevaju korišćenje sredstava i/ili opreme za ličnu zaštitu na radu, i da u skladu sa poslovima iz Priloga 3 ovog pravilnika propiše i obezbedi zaposlenima odgovarajuća sredstva i opremu za ličnu zaštitu na radu u skladu sa Prilogom 2 pravilnika.</2>
              <2>Pravilnik o sistematizaciji i organizaciji poslova (radnih mesta) je interni dokument jedne firme koji definiše i opisuje radni proces za svako radno mesto. Ovaj dokument mora biti u potpunosti usklađen sa Aktom o proceni rizika i mora biti polazna osnova pri proceni rizika pa se može reći da je dobra sistematizacija i organizacija poslova preduslov stručne i profesionalne procene rizika.</2>
            </3>
            <p>Treći stub u organizaciji bezbednosti i zdravlja na radu jeste osposobljavanje zaposlenih za bezbedan i zdrav rad, koje je i zakonska obaveza poslodavaca u skladu sa članom 15., 27., 28. i 29. Zakona o bezbednosti i zdravlju na radu. Osposobljavanje zaposlenih treba da prati odgovarajući Plan i Program osposobljavanja koji donosi stručna služba odnosno licencirana kuća. Osposobljavanje se vrši teorijski, putem odgovarajućih stručnih predavanja i seminara i provere znanja testiranjem, kao i praktično na samom radnom mestu u prisustvu neposrednog rukovodioca.</p>
            <p>Četvrti stub sistema BZR jeste organizovanje poslova bezbednosti i zdravlja na radu u skladu sa članom 37. Zakona o bezbednosti i zdravlju na radu, tj. određivanjestručnog lica za BZR. Poslodavac imenuju stručno lice za obavljanje poslova bezbednosti i zdravlja na radu u slučaju da imaju više od 20 zaposlenih radnika:</p>
            <3>
              <2>Imenovanjem 1 ili više zaposlenih iz svojih redova koji imaju položeni stručni ispit iz oblasti bezbednosti i zdravlja na radu kod Uprave za bezbednost i zdravlje na radu pri Ministarstvu rada i socijalne politike ili</2>
              <2>Angažovanjem spoljne stručne službe (Licencirane kompanije) radi obavljanja ovih poslova.</2>
              <2>Poslodavci koji zapošljavaju do 20 zaposlenih, u delatnostima trgovine na malo, usluga smeštaja i ishrane, informisanja i komunikacija, finan­sijskim i osiguranja, poslovanja nekretninama, stručnim, na­učnim, inovacionim, administrativnim i pomoćnim usluž­nim delatnostima, obaveznog socijalnog osiguranja, obrazo­vanja, umetnosti, zabave i rekreacije, kao i ostalim uslužnim delatnostima, mogu sami da obavljaju poslove bezbednosti i zdravlja na radu bez položenog stručnog ispita, s tim što stručno lice treba izraditi Akt o proceni rizika.</2>
              <2>Ovo četiri stuba predstavljaju suštinu bezbednosti i zdravlja na radu jedne firme, dok su sve ostale obaveze definisane Zakonom i odgovarajućim pravilnicima i dr. podzakonskim aktima.</2>
            </3>
            <4>Bezbednost i zdravlje na radu</4>
            <p>Kako bi poslodavci rešili zakonsku obavezu u skladu sa članom 37. Zakona o bezbednosti i zdravlju na radu, mogu sklopiti Ugovor o poslovno-tehničkoj saradnji sa BP Consulting Project-om i na taj način učiniti stručni tim stalno dostupnim i prisutnim u pogonima odnosno radnim prostorijama Vaše firme.</p>
            <p>Na taj način Institut preuzima na sebe odgovornost za čitav sistem bezbednosti i zdravlja na radu i što je najbitnije poslodavac se može u svakom trenutku apsolutno fokusirati na obavljanje svoje delatnosti i biti spokojan da se ceo sistem sprovodi.</p>
            <p>Jedan od najbitnijih koraka uspostavljanja sistema BZR jeste organizovanje poslova bezbednosti i zdravlja na radu u skladu sa članom 37. Zakona o bezbednosti i zdravlju na radu, tj. određivanje stručnog lica za BZR. Poslodavac imenuju stručno lice za obavljanje poslova bezbednosti i zdravlja na radu u slučaju da imaju više od 20 zaposlenih radnika:</p>
            <3>
              <2>Imenovanjem 1 ili više zaposlenih iz svojih redova koji imaju položeni stručni ispit iz oblasti bezbednosti i zdravlja na radu kod Uprave za bezbednost i zdravlje na radu pri Ministarstvu rada i socijalne politike ili</2>
              <2>Angažovanjem spoljne stručne službe (Licenciranog preduzeća) radi obavljanja ovih poslova).</2>
            </3>
            <p>Poslodavci koji zapošljavaju do 20 zaposlenih, u delatnostima trgovine na malo, usluga smeštaja i ishrane, informisanja i komunikacija, finan­sijskim i osiguranja, poslovanja nekretninama, stručnim, na­učnim, inovacionim, administrativnim i pomoćnim usluž­nim delatnostima, obaveznog socijalnog osiguranja, obrazo­vanja, umetnosti, zabave i rekreacije, kao i ostalim uslužnim delatnostima, mogu sami da obavljaju poslove bezbednosti i zdravlja na radu bez položenog stručnog ispita, s tim što stručno lice treba izraditi Akt o proceni rizika.</p>`,
    },
    siteSafetyCoordinator: {
      title: "Koordinator za bezbednost i zdravlje na gradilištima",
      text: `
            <p>Primena “Uredbe za bezbednost i zdravlje na radu na privremenim i pokretnim gradilištima” počela je od jula 2011. godine i ogleda se u tome da su investitori u obavezi da angažuju koordinatore za bezbednost i zdravlje na radu u fazi projektovanja i fazi izvođenja radova.
            Investitor, odnosno zastupnik investitora je dužan da odredi jednog ili više koordinatora za izradu projekta i jednog ili više koordinatora za izvođenje radova kada na gradilištu izvode ili je predviđeno da će radove izvoditi dva ili više izvođača radova istovremeno. S tim što treba napomenuti da se svako pravno lice koje izvodi radove tretira kao izvođač.
            Obaveze koordinatora u fazi projektovanja su:</p>
                <1>
                  <2>Vrši koordinaciju primene načela prevencije;</2>
                  <2>Izrađuje Plan preventivnih mera kojim je određeno uređenje gradilišta i specifične mere za bezbedan i zdrav rad na tom gradilištu;</2>
                  <2>Vodi računa da se pri izradi Plana preventivnih mera, kada je potrebno, uzmu u obzir sve industrijske aktivnosti u blizini gradilišta;</2>
                  <2>Priprema dokumenta, koja u skladu sa karakteristikama projekta, sadrže relevantne informacije iz oblasti bezbednosti i zdravlja na radu koje je potrebno uzeti u obzir u toku izvođenja svih radova na gradilištu.</2>
                </1>
                <p>Obaveze koordinatora u fazi izvođenja radova su:</p>
                <1>
                  <2>Vrši koordinaciju primene načela prevencije u slučajevima kada se: (1) odlučuje o tehničkim, tehnološkim i/ili organizacionim rešenjima, u cilju planiranja različitih elemenata ili faza radova koji treba da se izvode istovremeno ili jedan za drugim, (2) procenjuju rokovi potrebni za završetak tih radova ili faza radova;</2>
                  <2>Koordinira realizaciju planiranih aktivnosti sa ciljem da se obezbedi da poslodavci i druga lica</2>
                  <2>Predlaže pokretanje postupka izrade izmena ili dopuna Plana preventivnih mera </2>
                  <2>Organizuje saradnju i međusobno obaveštavanje svih poslodavaca i drugih lica koji istovremeno ili jedan za drugim izvode radove na gradilištu, vrši koordinaciju njihovih aktivnosti u pogledu sprovođenja mera za bezbednost i zdravlje na radu radi sprečavanja nastanka povreda na radu i profesionalnih bolesti;</2>
                  <2>Obezbeđuje da svi poslodavci i druga lica na gradilištu budu upoznati sa Planom preventivnih mera, odnosno sa njegovim izmenama ili dopunama;</2>
                  <2>Koordinira sporazume radi provere da se radne aktivnosti izvode pravilno;</2>
                  <2>Preduzima mere radi obezbeđivanja da pristup na gradilište imaju samo lica koja imaju dozvolu da mogu da uđu na gradilište;</2>
                  <2>Obaveštava nadležnu inspekciju rada o slučajevima kada poslodavci i druga lica ne primenjuju mere za bezbedan i zdrav rad.</2>
                </1>`,
    },
    energyEfficiency: {
      title: "Energy efficiency",
      text: `<3>
              <2>Izrada Elaborata energetske efikasnosti</2>
              <2>Izdavanje Energetskih pasoša za objekte</2>
              <2>Termovizijska snimanja opreme za rad, mašina i tehnololoških linija</2>
            </3>`,
    },
    geoInfraMonitoring: {
      title: "Geotechnical and infrastructure monitoring",
      text: "",
    },
    supervision: {
      title: "Supervision",
      text: "",
    },
    predictiveMaintenance: {
      title: "Prediktivno održavanje objekata",
      text: "",
    },
    design: {
      title: "Design",
      text: `<3>
              <2>Izrada Glavnog projekta zaštite od požara</2>
              <2>Projektovanje stabilnih sistema za gašenje požara</2>
              <2>Projektovanje stabilnih sistema za dojavu požara</2>
              <2>Projektovanje stabilnih sistema za detekciju eksplozivnih gasova i para</2>
              <2>Analiza o zonama opasnosti i određivanje ovih zona na mestima koja su ugrožena od nastanka eksplozivnih smeša zapaljivih gasova, para zapaljivih tečnosti i prašina</2>
              <2>Projektovanje električnih instalacija i uređaja za prostore ugrožene eksplozivnim atmosferama</2>
              <2>Projektovanje sistema za odvođenje dima i toplote</2>
              <2>Izrada projekata električnih i gromobranskih instalacija</2>
              <2>Izrada svih vrsta projekata mašinskih instalacija</2>
              <2>Tehnička kontrola projektno-tehničke dokumentacije</2>
              <2>Stručni nadzor za vreme izgradnje objekata</2>
            </3>`,
    },
    fireProtection: {
      title: "Fire protection",
      text: `<p>U skladu sa Zakonom o zaštiti od požara, BP Consulting Project može ponuditi sledeće usluge:</p>
            <3>
              <2>Vođenje poslova zaštite od požara</2>
              <2>Izrada Pravila zaštite od požara</2>
              <2>Izrada Planova zaštite od požara (za I i II kategoriju)</2>
              <2>Izrada Planova evakuacije i uputstva za postupanje u slučaju požara</2>
              <2>Izrada Programa osnovne obuke iz oblasti zaštite od požara</2>
              <2>Izrada Glavnog projekta zaštite od požara i projektovanje posebnih sistema zaštite od požara</2>
              <2>Izrada Elaborata, studija i analiza postojećeg stanja zaštite od požara</2>
              <2>Stručni nadzor i saveti iz oblasti zaštite od požara</2>
              <2>Pregled gromobranske instalacije sa merenjima električne otpornosti rasprostiranja uzemljivača</2>
              <2>Pregled i ispitivanja električne instalacije: neprekidnost zaštitnog provodnika, glavnog i dodatnog provodnika za izjednačenje potencijala, otpornost izolacije električne instalacije, zaštita električnim odvajanjem električne instalacije, otpornost podova i zidova, automatsko isključenje napajanja, dopunsko izjednačenje potencijala.</2>
              <2>Pregled protiveksplozijsko zaštićenih uređaja i električnih instalacija sa ocenom o primenjenosti mera protiveksplozijske zaštite</2>
              <2>Ispitivanje i provera nužnog funkcionalnog osvetljenja (panik rasvete)</2>
              <2>Merenje statičkog naelektrisanja</2>
              <2>Detekcija eksplozivnih gasova i para u radnoj okolini</2>
              <2>Merenje elektroprovodnih obloga (antistatik podova)</2>
              <2>Termovizijska snimanja opreme za rad, mašina i tehnoloških linija</2>
              <2>Organizovanje pregleda i servisiranja protivpožarnih aparata, hidrantske mreže i sistema za gašenje i dojavu požara</2>
              <2>Obuka zaposlenih iz oblasti zaštite od požara</2>
            </3>`,
    },
    environmentalProtection: {
      title: "Environmental protection",
      text: `<p>U skladu sa Zakonom o zaštiti životne sredine i dr. zakonskim i podzakonskim propisima, BP Consulting Project može ponuditi sledeće usluge:</p>
            <3>
              <2>Izrada Studije o proceni uticaja projekta na životnu sredinu</2>
              <2>Organizovanje merenja emisije zagađujućih materija u vazduh</2>
              <2>Organizovanje merenja buke u životnoj sredini</2>
              <2>Organizovanje ispitivanja otpadnih, površinskih i podzemnih voda</2>
              <2>Izrada plana prevencije zaštite od udesa</2>
              <2>Pružanje usluga savetnika za hemikalije</2>
              <2>Pružanje usluga savetnika za bezbednost u transportu opasnog tereta</2>
              <2>Pružanje usluga savetnika za upravljanje otpadom</2>
              <2>Izrada godišnjeg Izveštaja za posebne tokove otpada</2>
              <2>Izrada godišnjeg Izveštaja o količinama generisanog otpada</2>
              <2>Izrada Plana upravljanja otpadom</2>
              <2>Izrada potrebne dokumentacije za dobijanje dozvole za prevoz, skladištenje i tretman otpada</2>
            </3>`,
    },
    standardization: {
      title: "Standardizacija (HACCP, ISO)",
    },
    firstAid: {
      title: "First aid",
      text: `<p>Shodno obavezama firmi iz oblasti prve pomoći i odgovarajućeg minimalnog procenta broja zaposlenih koji moraju biti osposobljeni za organizovanje i pružanje prve pomoći, BP Consulting Project nudi svojim partnerima:</p>
            <3>
              <2>Stručno osposobljavanje radnika za organizovanje i pružanje prve pomoći (uz odgovarajući Program osposobljavanja i odgovarajuće materijale koje dobija svaki polaznik)</2>
            </3>`,
    },
    professionalTraining: {
      title: "Professional training and education",
      text: `<p>BP Consulting Project pored osnovne obuke za bezbedan i zdrav rad svakog zaposlenog, obavlja stručna osposobljavanja zaposlenih, na sledećim poslovima:</p>
            <3>
              <2>Rukovanje transportnim sredstvima (građevinske auto dizalice, mosne, konzolne i ostale, teretni i putnički liftovi, viljuškari, signalisti i vozači tereta, manevristi)</2>
              <2>Rukovanje opremom za rad (mašine za obradu drveta, metala, kamena, gume, papira, plastične mase)</2>
              <2>Rukovanje energetskim postrojenjima (kotlovska postrojenja, kompresorska postrojenja, gasni generatori, centralno grejanje i klimatizacija, uređaji za punjenje i manipulaciju tehničkim gasovima, crpna postrojenja, rashladni uređaji, trafostanice i razvodna postrojenja-uklopničari)</2>
              <2>Rukovanje građevinskom mehanizacijom (teška građevinska mehanizacija - bageri, buldožeri, skreperi, grejderi, valjci, finišeri, utovarivači, fabrike betona, asfaltne baze, separacije šljunka i peska, laka građevinska mehanizacija - mašine za ugrađivanje betona, mašine za sabijanje zemljanog i šljunkovitog materijala)</2>
              <2>Montaža i demontaža skele</2>
              <2>Zavarivanja i atestiranja (sve vrste zavarivanja - elektro, gasno, u zaštiti gasa; atestiranje varioca - osnovni, dopunski i specijalni test)</2>
              <2>Rukovanje opasnim materijama (prevoz i manipulacija opasnim meterijama, stručno osposobljavanje vozača motornih vozila kojima se prevoze opasne materije i dr. lica koja učestvuju u prevozu tih materija)</2>
              <2>Rukovanje i održavanje uređaja u protiveksplozivnoj zaštiti - ex zaštita</2>
              <2>Rukovanje gasnim hlorinatorima, pumpama, kompresorima i dr. (poslovi prerade vode za piće)</2>
            </3>`,
    },
    inspectionsTesting: {
      title: "Inspections and testing",
      text: `U skladu sa članom 15. Zakona o bezbednosti i zdravlju na radu i odredaba Pravilnika o postupku pregleda i provere opreme za rad i ispitivanja uslova radne okoline, poslodavac je u obavezi da vrši preventivne i periodične preglede i ispitivanje opreme za rad kao i ispitivanje uslova radne okoline u skladu sa definisanim rokovima.
            BP Consulting Project svojim klijentima može pružiti:<br />
            <3>
              <2>Pregled i proveru opreme za rad (svih vrsta dizalica, viljuškara, podiznih platformi, samohodnih vozila, presa, makaza, noževa, valjaka, stolarske opreme, mašine za obradu metala rezanjem i plastičnom deformacijom, protiveksplozijsko zaštićene opreme, privremene gradilišne električne instalacije i ostalih mašina koje podležu pregledima)</2>
              <2>Pregled i ispitivanje uslova radne okoline: merenje mikroklime, osvetljenja i štetnih zračenja, merenje i ispitivanje fizičkih štetnosti (buke i vibracija), merenje i ispitivanje hemijskih štetnosti</2>
              <2>Pregled i ispitivanje električnih instalacija (proizvodne hale, radionice, lokali i dr.)</2>
              <2>Pregled i ispitivanje gromobranskih instalacija (merenje specifičnog otpora tla)</2>
              <2>Ispitivanje i provera nužnog funkcionalnog osvetljenja (panik rasvete) </2>       
              <2>Termovizijska snimanja opreme za rad, mašina i tehnololoških linija</2>
            </3>`,
    },
  },
  footer: {
    copyright: `BP Consulting <1/> 2025. All rights reserved. Designed and developed by
          <0 href="https://tremium.net">Tremium Software</0>`,
    copyrightDesign: `Visual materials used on the site were downloaded from
          <0 href="https://www.freepik.com">Freepik</0>`,
  },
  password: {
    weak: "weak",
    average: "average",
    good: "good",
    strong: "strong",
  },
};
